export default __webpack_public_path__ + "static/media/icon-location.7e6459d2.svg";